import { AxiosResponse } from 'axios'

import ClientSDK from '../../../../../App/ClientSDK'

import {IAPIAvatarData} from './IAvatarData'
import Transformer from './Transformer'

class Client {
    static getAvatars = (uuid: string): Promise<any> =>
        ClientSDK.instance()
            .get(`hr/persons/${uuid}/avatars`)
            .then((response: AxiosResponse): any => {
                return response.data.list.map((data: IAPIAvatarData) => Transformer.transform(data))

              // return response.data

            })

    static changeAvatars = (uuid: string, fileUuid: string): Promise<any> =>
        ClientSDK.instance()
            .put(`hr/persons/${uuid}/avatar/change`, {
                file_uuid: fileUuid,
            })
            .then((response: AxiosResponse): any => {
                return response.data
            })

    static uploadAvatar = (uuid: string, avatarImages: File[]): Promise<any> => {
        const formData = new FormData();
        avatarImages.forEach((image) => formData.append('avatar', image));

        return ClientSDK.instance()
            .post(`hr/persons/${uuid}/avatar`, formData)
            .then((response: AxiosResponse): any => {
                return response.data;
            });
    }
}

export default Client
